import { render, staticRenderFns } from "./DashboardUpdatesCard.vue?vue&type=template&id=44ed573a&scoped=true&"
import script from "./DashboardUpdatesCard.vue?vue&type=script&lang=js&"
export * from "./DashboardUpdatesCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUpdatesCard.vue?vue&type=style&index=0&id=44ed573a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed573a",
  null
  
)

export default component.exports